import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export const PageHero = ({ eyebrow, title, description }) => (
  <section className="relative bg-brand-bg pt-32 sm:pt-40 pb-16 sm:pb-20 border-b border-brand-border/60">
    <div className="max-w-5xl mx-auto px-5 sm:px-8">
      <nav className="font-mono text-xs uppercase tracking-wider text-brand-muted mb-6">
        <Link to="/" className="hover:text-brand-orange transition-colors">Home</Link>
        <span className="mx-2 text-brand-border">/</span>
        <span className="text-brand-amber">{eyebrow}</span>
      </nav>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="font-mono text-xs uppercase tracking-widest text-brand-amber mb-3"
      >
        {eyebrow}
      </motion.p>
      <motion.h1
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="font-display font-extrabold uppercase tracking-tight text-brand-text text-4xl sm:text-5xl lg:text-6xl max-w-3xl"
      >
        {title}
      </motion.h1>
      {description && (
        <p className="mt-5 max-w-2xl text-brand-muted text-base sm:text-lg leading-relaxed">{description}</p>
      )}
    </div>
  </section>
);
